import React from "react";
import { Link } from "react-router-dom";
import LegalPageLayout from "@/components/site/LegalPageLayout";
import { LEGAL_ENTITY } from "@/data/legal";

const LAST_UPDATED = "11 de setembro de 2026";

export default function TermsOfUse() {
  return (
    <LegalPageLayout
      title="Termos de Uso"
      description={`Condições de uso do site da ${LEGAL_ENTITY.tradeName}.`}
      path="/termos-de-uso"
      lastUpdated={LAST_UPDATED}
    >
      <div className="mn-legal-notice">
        <strong>Aviso:</strong> este é um modelo de referência, baseado em modelos comuns de
        mercado — não foi validado por um advogado. Passe por revisão jurídica antes de considerar
        esta página definitiva.
      </div>

      <h2>1. Objeto</h2>
      <p>
        Este site é um catálogo digital de produtos e canal de geração de orçamentos da{" "}
        <strong>{LEGAL_ENTITY.tradeName}</strong> ({LEGAL_ENTITY.legalName}, CNPJ{" "}
        {LEGAL_ENTITY.cnpj}). <strong>Não é uma loja virtual</strong> — não há carrinho de compras
        nem pagamento online; toda venda é fechada diretamente com nossa equipe, após um orçamento
        personalizado.
      </p>

      <h2>2. Uso permitido</h2>
      <p>
        Você pode navegar pelo catálogo, ler o conteúdo do blog e enviar solicitações de orçamento
        ou contato. É proibido usar o site para qualquer finalidade ilícita, tentar acessar áreas
        restritas sem autorização (como o painel administrativo), ou extrair conteúdo do site de
        forma automatizada (scraping) sem autorização prévia.
      </p>

      <h2>3. Preços, prazos e disponibilidade</h2>
      <p>
        Preços não são exibidos no site — todo valor é calculado sob consulta, conforme
        especificação, quantidade e prazo do seu pedido, e informado em um orçamento formal.
        Especificações de produto (materiais, tamanhos, prazos de produção) exibidas no site são
        referenciais e podem variar; o orçamento enviado é o documento que vale para efeitos
        comerciais.
      </p>

      <h2>4. Propriedade intelectual</h2>
      <p>
        Todo o conteúdo deste site — textos, fotos de produtos e de projetos entregues, logotipo,
        identidade visual e código — pertence à {LEGAL_ENTITY.tradeName} ou é usado com autorização
        de seus respectivos titulares (incluindo clientes que autorizaram o uso de fotos de
        projetos entregues como referência de portfólio). Não é permitido reproduzir, copiar ou
        redistribuir esse conteúdo sem autorização prévia por escrito.
      </p>
      <p>
        A arte/logotipo que você envia na ferramenta de mock-up continua sendo sua — nós só a
        usamos temporariamente para gerar o preview visual, sem armazená-la (ver{" "}
        <Link to="/politica-de-privacidade">Política de Privacidade</Link>).
      </p>

      <h2>5. Links e serviços de terceiros</h2>
      <p>
        Este site contém links para serviços de terceiros — WhatsApp, Instagram, e (quando você
        consentir) ferramentas de analíticos como Google Analytics. Não temos controle sobre esses
        serviços e não nos responsabilizamos pelo conteúdo ou pelas políticas de privacidade
        deles.
      </p>

      <h2>6. Isenção de responsabilidade</h2>
      <p>
        Fazemos esforço razoável para manter as informações deste site atualizadas e corretas, mas
        não garantimos ausência total de erros ou que o site estará disponível
        ininterruptamente. Imagens de produtos podem apresentar pequenas variações em relação ao
        produto final entregue.
      </p>

      <h2>7. Alterações destes termos</h2>
      <p>
        Podemos atualizar estes Termos de Uso a qualquer momento. A data da última atualização
        está sempre indicada no topo desta página. O uso continuado do site após uma alteração
        significa que você concorda com os novos termos.
      </p>

      <h2>8. Legislação aplicável e foro</h2>
      <p>
        Estes termos são regidos pela legislação brasileira. Fica eleito o foro da comarca de{" "}
        {LEGAL_ENTITY.city}/{LEGAL_ENTITY.state} para dirimir quaisquer controvérsias decorrentes
        deste documento, com renúncia a qualquer outro, por mais privilegiado que seja.{" "}
        <em>[TODO: confirmar o foro com orientação jurídica.]</em>
      </p>
    </LegalPageLayout>
  );
}
